// Pure date/time helpers for the car-booking flow. They live apart from
// useStationSchedule so the Pinia store can use them without importing a module
// that imports the store back.

// Pickup/dropoff times are station-local wall-clock. The gateway extracts the
// hour via new Date()+getUTCHours(), so we append "Z" to pin the digits the
// agent typed regardless of the gateway host's timezone (its tests assume Z).
export const isoAt = (date, time) =>
  date && time ? `${date}T${time}:00Z` : null;

// Today's date as a local "YYYY-MM-DD" string (no UTC round-trip).
export const todayStr = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};
